import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import Footer from "../layouts/footer/Footer";
import ShopMain from "../layouts/main/ShopMain";
import PRODUCT_CHUNK, { DEFAULT_LANGUAGE } from "../utils/global_const";
import { useParams } from "react-router-dom";
import { ProductContext } from "../context/ProductContext";
import Header from "../layouts/header/Header";
import brandDescriptions from "../brand_descriptions.json";

const SEOConfig = {
  en: {
    title: "B2B Wholesale | SnusCo Austria",
    description:
      "Discover our B2B wholesale platform at b2b.snusco.at offering premium nicotine pouches for tabak shops across Austria and Europe. Benefit from competitive pricing, flexible order quantities and fast delivery.",
    keywords:
      "wholesale nicotine pouches, B2B nicotine pouches, nicotine pouch wholesaler, SnusCo B2B, tabak shop supply, snus wholesale Austria, Europe nicotine pouches",
    url: "https://b2b.snusco.at/en/wholesale",
    images: ["https://b2b.snusco.at/assets/default-brand-image.jpg"],
  },
  de: {
    title: "B2B Großhandel | SnusCo Österreich",
    description:
      "Entdecken Sie unsere B2B-Großhandelsplattform auf b2b.snusco.at für hochwertige Nikotinbeutel in Tabakshops in ganz Österreich und Europa. Profitieren Sie von wettbewerbsfähigen Preisen, flexiblen Bestellmengen und schneller Lieferung.",
    keywords:
      "Nikotinbeutel Großhandel, B2B Nikotinbeutel, Snus Großhändler, SnusCo B2B, Tabakshop Großhandel, Snus Großhandel Österreich, Europa Nikotinbeutel",
    url: "https://b2b.snusco.at/de/grosshandel",
    images: ["https://b2b.snusco.at/assets/default-brand-image.jpg"],
  },
};

const Shop = () => {
  const { i18n } = useTranslation();
  const { slug } = useParams();
  const [seo, setSeo] = useState(SEOConfig[DEFAULT_LANGUAGE]);
  const { loadProducts } = useContext(ProductContext);

  useEffect(() => {
    // Odredi jezik
    const lang = i18n.language === "de" ? "de" : "en";
    const defaultSEO = SEOConfig[lang] || SEOConfig[DEFAULT_LANGUAGE];

    // Pokušaj da nadješ brend po slug-u
    const entry = brandDescriptions.find((item) => item.slug === slug);

    if (entry) {
      const descKey = lang === "de" ? "short_desc_de" : "short_desc_en";
      const seoDescription = entry[descKey] || defaultSEO.description;
      const seoTitle = `${entry.brand_name} | SnusCo B2B`;
      const categoryUrl = `https://b2b.snusco.at/${lang}/wholesale/${slug}`;

      setSeo({
        title: seoTitle,
        description: seoDescription,
        keywords: `${entry.brand_name}, ${defaultSEO.keywords}`,
        url: categoryUrl,
        images: defaultSEO.images,
      });
      loadProducts();
    } else {
      // Fallback na generički SEOConfig
      loadProducts();
      setSeo(defaultSEO);
    }
  }, [slug, i18n.language]);

  return (
    <div>
      <Helmet>
        <html lang={i18n.language} />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seo.url} />

        {/* Open Graph slike - Primarna slika na prvom mestu */}
        {seo.images?.map((image, index) => (
          <meta key={index} property="og:image" content={image} />
        ))}

        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="author" content="SnusCo" />
        <link rel="canonical" href={seo.url} />
      </Helmet>
      <Header />
      <ShopMain />
      <Footer />
    </div>
  );
};

export default Shop;
